import React from 'react';

import './siteJabber.scss';
import {INSTANT_FEEDBACK_WIDGET_ID} from 'constants/popupNames';

/**
 * Site jabber layout for render popup
 * @returns {JSX.Element} - return JSX component
 */
export const SiteJabber: React.FC = () => (
    <div id={INSTANT_FEEDBACK_WIDGET_ID}>
        <div className="stjr-widget" id="InstantFeedbackWidgetInner" />
    </div>
);
